<template>
    <div>
        <div class="container new-session px-4 py-4">
            <div v-if="showCreationWarning" class="notification is-warning">
                <button
                    class="delete"
                    @click="showCreationWarning = false"
                ></button>
                <p
                    v-if="this.$store.getters.project.type == 'treasurehunt'"
                    v-html="$t('Sessions.update_treasurehunt_warning')"
                ></p>
                <p v-else v-html="$t('Sessions.update_trivial_warning')"></p>
            </div>

            <div v-if="showCreationError" class="notification is-danger">
                <button
                    class="delete"
                    @click="showCreationError = false"
                ></button>
                {{ creationError }}
            </div>
            <!--<div
            v-if="!$store.getters.projectContent.length"
            class="notification is-danger"
        >
            <p v-t="'Sessions.creation_empty_project'"></p>
        </div>-->

            <form class="">
                <div class="columns is-mobile is-vcentered is-multiline">
                    <div class="column is-12">
                        <div class="field mb-5">
                            <label
                                v-t="'Sessions.session_name'"
                                class="label"
                            ></label>
                            <div class="control">
                                <input
                                    v-model="session.title"
                                    :placeholder="$t('Sessions.session_name')"
                                    class="input"
                                    type="text"
                                />
                            </div>
                        </div>

                        <div class="field">
                            <label
                                v-t="'Sessions.show_at_end'"
                                class="label"
                            ></label>
                            <div class="control is-expanded">
                                <textarea
                                    rows="3"
                                    v-model="session.configuration.feedback"
                                    :placeholder="
                                        $t('Sessions.end_of_game_info')
                                    "
                                    class="textarea has-fixed-size"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <label
                            v-t="'Sessions.play_mode_select'"
                            for="appmode"
                            class="label"
                        ></label>
                        <div class="level is-mobile mb-2">
                            <div class="level-item mr-0">
                                <span
                                    ref="appButton"
                                    class="
                                        button
                                        is-light is-fullwidth
                                        has-tooltip-bottom has-tooltip-multiline
                                    "
                                    :data-tooltip="
                                        $t(`Sessions.play_mode_select_app`)
                                    "
                                    :class="{
                                        'is-primary': isApp,
                                    }"
                                    @click.stop="setApp"
                                >
                                    <span class="icon is-small">
                                        <i
                                            class="
                                                mdi
                                                mdi-18px
                                                mdi-tablet-cellphone
                                            "
                                        ></i>
                                    </span>
                                    <span>APP</span>
                                </span>
                            </div>
                            <div class="level-item mr-0">
                                <span
                                    ref="webButton"
                                    class="
                                        button
                                        is-light is-fullwidth
                                        has-tooltip-bottom has-tooltip-multiline
                                    "
                                    :class="{
                                        'is-primary': isWeb,
                                    }"
                                    :data-tooltip="
                                        $t(`Sessions.play_mode_select_web`)
                                    "
                                    @click.stop="setWeb"
                                >
                                    <span class="icon is-small">
                                        <i class="mdi mdi-18px mdi-laptop"></i>
                                    </span>
                                    <span>WEB</span>
                                </span>
                            </div>
                        </div>

                        <label
                            v-if="session.configuration.app"
                            v-t="'Sessions.play_mode_select_app_hint'"
                            for="appmode"
                            class="label is-italic"
                        ></label>
                        <label
                            v-else
                            v-t="'Sessions.play_mode_select_web_hint'"
                            for="appmode"
                            class="label is-italic"
                        ></label>

                        <div class="field mb-3 pt-4" v-if="isModeMap">
                            <label class="switch">
                                <input
                                    id="closer"
                                    v-model="session.configuration.closer"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.have_to_be_close'"
                                for="closer"
                                class="pl-3"
                            ></label>
                        </div>

                        <div class="field pt-4">
                            <label class="switch">
                                <input
                                    id="allowsReset"
                                    v-model="session.allowsReset"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.allows_reset'"
                                for="allowsReset"
                                class="pl-3"
                            ></label>
                        </div>
                    </div>
                </div>

                <hr />

                <div class="columns is-mobile is-vcentered is-multiline">
                    <div class="column is-12 pb-0">
                        <div class="field mb-3 mt-3">
                            <label class="switch">
                                <input
                                    id="availability"
                                    v-model="session.configuration.availability"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <label
                                v-t="'Sessions.game_availability'"
                                for="availability"
                                class="pl-3"
                            ></label>
                        </div>
                    </div>
                </div>

                <div
                    class="columns is-mobile is-vcentered is-multiline"
                    v-if="limitedAvailability"
                >
                    <div class="column is-12 pt-4">
                        <div class="field">
                            <label
                                v-t="'Sessions.start_date'"
                                class="label"
                            ></label>
                            <div class="field-body">
                                <InputDatetime
                                    v-model="session.configuration.startDate"
                                    :min-date="minDate"
                                ></InputDatetime>
                            </div>
                        </div>
                    </div>

                    <div class="column is-12 pt-0">
                        <div class="field">
                            <label
                                v-t="'Sessions.limit_date'"
                                class="label"
                            ></label>
                            <div class="field-body">
                                <InputDatetime
                                    v-model="session.configuration.limitDate"
                                    :min-date="minDate"
                                ></InputDatetime>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- action buttons -->
        <div
            class="
                columns
                is-mobile
                action-buttons
                px-0
                py-0
                has-background-white
            "
        >
            <div class="column is-6 px-0 py-0">
                <button
                    v-t="'cancel'"
                    class="
                        button
                        is-black is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="discardUnsavedChanges"
                />
            </div>
            <div class="column is-6 px-0 py-0">
                <button
                    v-t="'Buttons.save'"
                    :class="{ 'is-loading': saving }"
                    class="
                        button
                        is-primary is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="updateSession"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { updateItem } from '@/services/API';
import InputDatetime from '@/components/InputDatetime';
import moment from 'moment';
import _ from 'underscore';
export default {
    components: {
        InputDatetime,
    },
    props: {
        session: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },

    data() {
        return {
            creating: false,
            allowsReset: false,
            showCreationWarning: true,
            showCreationError: false,
            creationError: false,
            minDate: moment().toISOString(),
            saving: false,
        };
    },
    computed: {
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        objects() {
            return this.$store.getters.projectContent;
        },
        limitedAvailability() {
            return this.session.configuration.availability;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
        isWeb() {
            // console.log('isWeb', this.session.configuration.web === true);
            return (
                this.session.configuration.web &&
                !this.session.configuration.app
            );
        },
        isApp() {
            // console.log('isApp', this.session.configuration.app === true);
            return (
                this.session.configuration.app &&
                !this.session.configuration.web
            );
        },
    },
    methods: {
        async updateSession() {
            // console.log('session data', this.session);
            // console.log('projectContent', this.$store.getters.projectContent);
            // console.log('original context', [...this.session.context]);
            this.saving = true;
            let newContext = [];
            this.session.context.forEach((element) => {
                let updateObject = _.findWhere(
                    this.$store.getters.projectContent,
                    {
                        _id: element._id,
                    }
                );
                if (updateObject) {
                    let objectToInclude = { ...updateObject };
                    delete objectToInclude.watchers;
                    delete objectToInclude.likes;
                    delete objectToInclude.liked;
                    delete objectToInclude.accessLevel;
                    if (
                        objectToInclude.comments &&
                        objectToInclude.comments.length == 0
                    ) {
                        delete objectToInclude.comments;
                    }
                    newContext.push(objectToInclude);
                } else {
                    newContext.push({ ...element });
                }
            });
            //console.log(newContext);
            this.session.context = newContext;
            // console.log('new session context', this.session.context);
            let response = await updateItem(
                'session',
                this.session._id,
                this.session
            )
                .then(() => {
                    this.$emit('close');
                    this.saving = false;
                })
                .catch(() => {
                    this.error = true;
                    this.saving = false;
                });
        },
        setApp() {
            this.configuration.app = true;
            this.configuration.web = false;
            if (!this.$refs.appButton.classList.contains('is-primary')) {
                this.$refs.appButton.classList.add('is-primary');
                this.$refs.webButton.classList.remove('is-primary');
            }
        },
        setWeb() {
            this.configuration.app = false;
            this.configuration.web = true;
            if (!this.$refs.webButton.classList.contains('is-primary')) {
                this.$refs.webButton.classList.add('is-primary');
                this.$refs.appButton.classList.remove('is-primary');
            }
        },
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },
    },
};
</script>

<style scoped>
.new-session {
    overflow-y: auto;
    max-height: calc(100vh - 165px);
    overflow-x: hidden;
}
.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}
.action-buttons button {
    height: 60px;
}
</style>
